import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const ContentContainer = styled(Box)`
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  //margin: 20px 0;
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const ButtonSpacer = styled(Box)`
  width: 10px;
`;
